export const disparityScoreDescription = (value: number): string => {
  const ranges: { min: number; max: number; description: string }[] = [
    { min: 0, max: 0.4, description: 'much less often' },
    { min: 0.4, max: 0.6, description: 'about half as often' },
    { min: 0.6, max: 0.9, description: 'somewhat less often' },
    { min: 0.9, max: 1.1, description: 'approximately just as often' },
    { min: 1.1, max: 1.4, description: 'slightly more often' },
    { min: 1.4, max: 1.8, description: 'somewhat more often' },
    { min: 1.8, max: 2.2, description: 'approximately twice as often' },
    { min: 2.2, max: 2.7, description: 'over twice as often' },
    { min: 2.7, max: 3.3, description: 'approximately three times as often' },
    { min: 3.3, max: 3.7, description: 'over three times as often' },
    { min: 3.7, max: 4.4, description: 'approximately four times as often' },
    { min: 4.4, max: 4.6, description: 'over four times as often' },
    { min: 4.6, max: 5.5, description: 'approximately five times as often' },
    { min: 5.5, max: 6.5, description: 'approximately six times as often' },
    { min: 6.5, max: 7.5, description: 'approximately seven times as often' },
    { min: 7.5, max: 8.5, description: 'approximately eight times as often' },
    { min: 8.5, max: 9.5, description: 'approximately nine times as often' },
    { min: 9.5, max: 10.5, description: 'approximately ten times as often' },
    { min: 10.5, max: 18, description: 'over ten times as often' },
    { min: 18, max: 23, description: 'approximately twenty times as often' },
  ];

  if (value >= 23) {
    const roundedToFive = Math.round(value / 5) * 5;
    return `approximately ${roundedToFive} times more often`;
  }

  for (const range of ranges) {
    if (value >= range.min && value < range.max) {
      return range.description;
    }
  }

  return 'unknown';
};
